import script from "./MainInput.vue?vue&type=script&setup=true&lang=js"
export * from "./MainInput.vue?vue&type=script&setup=true&lang=js"

import "./MainInput.vue?vue&type=style&index=0&id=4b76f9e1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b76f9e1"]])

export default __exports__